import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ProductContext = createContext(null);

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [productId, setProductIdState] = useState(localStorage.getItem("mai_product") || "tavi");

  const refresh = () => {
    axios.get(`${API}/products`).then((r) => {
      setProducts(r.data);
      if (r.data.length && !r.data.some((p) => p.id === (localStorage.getItem("mai_product") || "tavi"))) {
        setProductIdState(r.data[0].id);
      }
    }).catch(console.error);
  };

  useEffect(() => { refresh(); }, []);

  const setProductId = (id) => {
    localStorage.setItem("mai_product", id);
    setProductIdState(id);
  };

  const product = products.find((p) => p.id === productId);
  return (
    <ProductContext.Provider value={{ products, productId, setProductId, product, refresh }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => useContext(ProductContext);
